export const environment = {
  production: true,
  api_url: `https://api.homologacao.provadevida.app.br`,
  cliente: {
    municipio: 'Fortaleza/CE',
    siafi: 981389,
    slug: 'homologacao',
    logo_interna: './assets/icons/prova-vida/logo.png',
    logo_home: './assets/icons/prova-vida/logo.png',
    favicon_url: './assets/icons/prova-vida/logo.png',
    titulo: 'Substituído no Deploy',
    chave_interna: '123',
    censo_id: 19
  },
  firebase: {
    apiKey: 'AIzaSyBvMEtFiME-VH7_aMiWmBay70Q5hnUvihs',
    authDomain: 'censo-f83da.firebaseapp.com',
    projectId: 'censo-f83da',
    storageBucket: 'censo-f83da.appspot.com',
    messagingSenderId: '696675986609',
    appId: '1:696675986609:web:bc28c7b6a565f72b04c690',
    measurementId: 'G-ZJN1S77P7K'
  }
};
